import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'

interface UseDeletePublicCompanyLeadContractProduct {
  publicCompanyLeadId?: string
  onSuccess?: (response: AxiosResponse) => void
  onError?: (error: ErrorResponse) => void
}

export const useDeletePublicCompanyLeadContractProduct = ({
  publicCompanyLeadId,
  onSuccess,
  onError,
}: UseDeletePublicCompanyLeadContractProduct) => {
  const publicAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['deletePublicCompanyLeadContractProduct'],
    mutationFn: async (productCategoryId: string) => {
      const contract = {
        contract_product_categories_attributes: [
          {
            id: productCategoryId,
            _destroy: true,
          },
        ],
      }

      return await publicAxios.put(`/funnel/public/leads/${publicCompanyLeadId}/update_contract_products`, {
        contract,
      })
    },
    onSuccess,
    onError,
  })
}
